import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "manager-filter-drawer__close-trigger" }
const _hoisted_2 = { class: "manager-filter-drawer__fields-row" }
const _hoisted_3 = { class: "manager-filter-drawer__fields-section" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import { computed, reactive, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import {
  Col as ACol,
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Row as ARow,
  Select as ASelect,
  Space as ASpace,
} from 'ant-design-vue';
import type { ManagerReportsClusterOption, ManagerReportsFilter } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsFilterDrawer',
  props: {
    open: { type: Boolean },
    clusters: {},
    statusOptions: {},
    yearOptions: {},
    filter: {}
  },
  emits: ["update:open", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const draft = reactive<ManagerReportsFilter>({
  clusterId: undefined,
  statusId: undefined,
  year: undefined,
});

const clusterOptions = computed(() =>
  props.clusters.map((cluster) => ({
    value: cluster.id,
    label: cluster.name,
  })),
);

function normalizeFilter(filter: ManagerReportsFilter): ManagerReportsFilter {
  return {
    clusterId: filter.clusterId || undefined,
    statusId: filter.statusId || undefined,
    year: filter.year || undefined,
  };
}

function filtersEqual(a: ManagerReportsFilter, b: ManagerReportsFilter): boolean {
  const left = normalizeFilter(a);
  const right = normalizeFilter(b);

  return (
    left.clusterId === right.clusterId &&
    left.statusId === right.statusId &&
    left.year === right.year
  );
}

const hasDraftValues = computed(() => Boolean(draft.clusterId || draft.statusId || draft.year));

const hasChanges = computed(() => !filtersEqual(draft, props.filter));

const isResetDisabled = computed(() => !hasDraftValues.value);
const isApplyDisabled = computed(() => !hasChanges.value);

watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) return;

    draft.clusterId = props.filter.clusterId;
    draft.statusId = props.filter.statusId;
    draft.year = props.filter.year;
  },
);

function handleReset() {
  draft.clusterId = undefined;
  draft.statusId = undefined;
  draft.year = undefined;
}

function handleApply() {
  emit('apply', {
    clusterId: draft.clusterId || undefined,
    statusId: draft.statusId || undefined,
    year: draft.year || undefined,
  });
  emit('update:open', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ADrawer), {
    width: 800,
    open: __props.open,
    class: "company-editing-drawer manager-filter-drawer manager-filter-drawer--reports",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:open', false)))
  }, {
    title: _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createElementVNode("span", { class: "company-editing-drawer__title" }, "Фильтр", -1)
    ]))]),
    closeIcon: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(ARow), {
        align: "middle",
        justify: "end",
        class: "manager-filter-drawer__toolbar"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ACol), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ASpace), null, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline btn-medium",
                    disabled: isResetDisabled.value,
                    onClick: handleReset
                  }, " Сбросить ", 8, _hoisted_4),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-medium",
                    disabled: isApplyDisabled.value,
                    onClick: handleApply
                  }, " Применить ", 8, _hoisted_5)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(AForm), {
        layout: "vertical",
        class: "manager-filter-drawer__form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(AFormItem), {
              label: "Статус",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.statusId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((draft.statusId) = $event)),
                  "allow-clear": "",
                  placeholder: "Все статусы",
                  options: __props.statusOptions
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_unref(AFormItem), {
              label: "Отчетный период",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.year,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((draft.year) = $event)),
                  "allow-clear": "",
                  placeholder: "Все периоды",
                  options: __props.yearOptions
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(AFormItem), {
              label: "Кластер",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.clusterId,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((draft.clusterId) = $event)),
                  "allow-clear": "",
                  placeholder: "Все кластеры",
                  options: clusterOptions.value
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})